module.exports = __webpack_public_path__ + "img/app_img4.df68b486.png";